import { useTheme } from '@/context/ThemeContext';

export default function FinalCTA() {
  const { isDark } = useTheme();

  return (
    <section
      id="contact"
      className={`py-40 px-6 relative overflow-hidden transition-colors duration-500 ${isDark ? 'bg-[#0D1B2A]' : 'bg-[#F5F8FA]'}`}
    >
      {/* Radial Glow Centerpiece */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1200px] h-[1200px] pointer-events-none">
        <div className="absolute inset-0 bg-gradient-radial from-[#14B8A6]/20 via-[#14B8A6]/5 to-transparent rounded-full blur-3xl animate-pulse" />
        <div className="absolute inset-0 bg-gradient-radial from-[#14B8A6]/10 via-transparent to-transparent rounded-full" />
      </div>

      {/* Convergence Lines */}
      <div className="absolute inset-0 opacity-20">
        <svg className="absolute w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="ctaGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" style={{ stopColor: '#14B8A6', stopOpacity: 0 }} />
              <stop offset="50%" style={{ stopColor: '#14B8A6', stopOpacity: 1 }} />
              <stop offset="100%" style={{ stopColor: '#14B8A6', stopOpacity: 0 }} />
            </linearGradient>
          </defs>
          <line x1="0%" y1="50%" x2="50%" y2="50%" stroke="url(#ctaGradient)" strokeWidth="1" />
          <line x1="100%" y1="50%" x2="50%" y2="50%" stroke="url(#ctaGradient)" strokeWidth="1" />
          <line x1="25%" y1="0%" x2="50%" y2="50%" stroke="url(#ctaGradient)" strokeWidth="0.5" opacity="0.5" />
          <line x1="75%" y1="0%" x2="50%" y2="50%" stroke="url(#ctaGradient)" strokeWidth="0.5" opacity="0.5" />
          <line x1="25%" y1="100%" x2="50%" y2="50%" stroke="url(#ctaGradient)" strokeWidth="0.5" opacity="0.5" />
          <line x1="75%" y1="100%" x2="50%" y2="50%" stroke="url(#ctaGradient)" strokeWidth="0.5" opacity="0.5" />
          <circle cx="50%" cy="50%" r="8" fill="#14B8A6" opacity="0.6">
            <animate attributeName="r" values="8;12;8" dur="3s" repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.6;1;0.6" dur="3s" repeatCount="indefinite" />
          </circle>
        </svg>
      </div>

      <div className="max-w-5xl mx-auto text-center relative z-10">
        <h2 className={`text-5xl md:text-7xl font-bold mb-8 tracking-tight leading-[1.1] transition-colors duration-500 ${isDark ? 'text-white' : 'text-[#0D1B2A]'}`}>
          Bring Operational Clarity<br />to Your Business
        </h2>
        <p className={`text-xl md:text-2xl mb-14 max-w-3xl mx-auto leading-relaxed font-light transition-colors duration-500 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
          Vilaris AI helps businesses replace complexity with coordinated intelligent systems.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
          <button className="bg-[#14B8A6] text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-[#0F9688] hover:shadow-[0_0_40px_rgba(20,184,166,0.4)] transition-all duration-500 whitespace-nowrap cursor-pointer group">
            <span className="inline-block group-hover:scale-105 transition-transform duration-300">
              Schedule Your Strategy Call
            </span>
          </button>
          <button
            className={`border-2 px-10 py-5 rounded-full text-lg font-semibold transition-all duration-500 whitespace-nowrap cursor-pointer backdrop-blur-sm ${
              isDark
                ? 'border-white/20 text-white hover:border-[#14B8A6] hover:bg-[#14B8A6]/10 hover:text-[#14B8A6]'
                : 'border-[#0D1B2A]/20 text-[#0D1B2A] hover:border-[#14B8A6] hover:bg-[#14B8A6]/10 hover:text-[#14B8A6]'
            }`}
          >
            Explore Our Solutions
          </button>
        </div>

        <div className="mt-20 flex items-center justify-center gap-3 opacity-40">
          <div className="w-20 h-px bg-gradient-to-r from-transparent to-[#14B8A6]" />
          <div className="w-1.5 h-1.5 rounded-full bg-[#14B8A6]" />
          <div className="w-40 h-px bg-[#14B8A6]" />
          <div className="w-1.5 h-1.5 rounded-full bg-[#14B8A6]" />
          <div className="w-20 h-px bg-gradient-to-l from-transparent to-[#14B8A6]" />
        </div>
      </div>
    </section>
  );
}
